export default [
  {
    title: "",
    description: "",
    image: "slide_1_11_1.jpg",
    introducedInVersion: "1.11.50"
  },
  {
    title: "",
    description: "",
    image: "slide_1_11_2.png",
    introducedInVersion: "1.11.50"
  },
  {
    title: "",
    description: "",
    image: "slide_1_11_3.jpg",
    introducedInVersion: "1.11.50"
  },
  {
    title: "",
    description: "",
    image: "slide_1_11_4.jpg",
    introducedInVersion: "1.11.50"
  },
  {
    title: "",
    description: "",
    image: "slide_1_11_5.jpg",
    introducedInVersion: "1.11.50"
  },
  {
    title: "",
    description: "",
    image: "slide_1_11_6.jpg",
    introducedInVersion: "1.11.50"
  },
  {
    title: "",
    description: "",
    image: "slide_1_11_7.jpg",
    introducedInVersion: "1.11.50"
  }
];
